// extracted by mini-css-extract-plugin
export default {"header":"Reports_header__xkUSO","row":"Reports_row__vSur3","column":"Reports_column__f5WrJ"};